import { createAction } from '@reduxjs/toolkit';

export const updateRag = createAction<string>('UPDATE_RAG');
